import { __decorate, __param } from '../../../../../../../../../../external/tslib/tslib.es6.js';
import { IInstantiationService } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { CellContentPart } from '../../cellPart.js';
import { NotebookCellChatController } from './cellChatController.js';
import './cellChatActions.js';
import { IConfigurationService } from 'monaco-editor/esm/vs/platform/configuration/common/configuration.js';
import { NotebookSetting } from '../../../../common/notebookCommon.js';
let CellChatPart = class CellChatPart extends CellContentPart {
    get activeCell() {
        return this.currentCell;
    }
    constructor(_notebookEditor, _partContainer, _instantiationService, _configurationService) {
        super();
        this._notebookEditor = _notebookEditor;
        this._partContainer = _partContainer;
        this._instantiationService = _instantiationService;
        this._configurationService = _configurationService;
    }
    didRenderCell(element) {
        this._controller?.dispose();
        const enabled = this._configurationService.getValue(NotebookSetting.cellChat);
        if (enabled) {
            this._controller = this._instantiationService.createInstance(NotebookCellChatController, this._notebookEditor, this, element, this._partContainer);
        }
        super.didRenderCell(element);
    }
    unrenderCell(element) {
        this._controller?.dispose();
        this._controller = undefined;
        super.unrenderCell(element);
    }
    updateInternalLayoutNow(element) {
        this._controller?.layout();
    }
    dispose() {
        this._controller?.dispose();
        this._controller = undefined;
        super.dispose();
    }
};
CellChatPart = ( __decorate([
    ( __param(2, IInstantiationService)),
    ( __param(3, IConfigurationService))
], CellChatPart));
export { CellChatPart };
